// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { Link } from "react-router-dom";
// import Header from "../../Header/Header";
// import "../../../styles/style.css";
// import HeaderFunctions from "../../HeaderFunctions/HeaderFunctions";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faTimes, faCheck } from "@fortawesome/free-solid-svg-icons";
// import Sidebar from "../sidebar";



// const hapi_fhir = () => {
//   return (
//     <>
//       <Header
//       />
//       <div className="container">
//         <nav style={{ "--bs-breadcrumb-divider": ">" }} aria-label="breadcrumb">
//           <ol className="breadcrumb">
//             <li className="breadcrumb-item">
//               <Link to="#"></Link>
//             </li>
//             <li className="breadcrumb-item">
//               <Link to="#"></Link>
//             </li>
//             <li className="breadcrumb-item active" aria-current="page"></li>
//           </ol>
//         </nav>
//       </div>
//       <div className="container pb-4">
//         <div className="box-bdr-dash">
//           <div className="row">
//             <Sidebar/>
//             <div className="col-md-10">
//               <div className="box mb-2">
//                 <iframe src="http://208.109.243.219:8080/" width="100%" height="600" />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default hapi_fhir;


// const Component = React.createClass({
//     iframe: function () {
//       return {
//         __html: this.props.iframe
//       }
//     },
  
//     render: function() {
//       return (
//         <div>
//           <div dangerouslySetInnerHTML={ this.iframe() } />
//         </div>
//       );
//     }
//   });
  
  //const iframe = '<iframe src="https://hapi.fhir.org/" width="540" height="450"></iframe>'; 
  
 //export default hapi_fhir;

import React from "react";
import axios from "axios";
import { Link, useLocation } from "react-router-dom"; // ✅ useLocation imported
import Header from "../../Header/Header";
import "../../../styles/style.css";
import HeaderFunctions from "../../HeaderFunctions/HeaderFunctions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faCheck } from "@fortawesome/free-solid-svg-icons";
import Sidebar from "../sidebar";

const Hapi_Fhir = () => {
  const location = useLocation(); // ✅ location hook
  const queryParams = new URLSearchParams(location.search);
  const isHeaderLink = queryParams.get("source") === "header"; // ✅ check query param

  return (
    <>
      <Header />

      <div className="container">
        <nav
          style={{ "--bs-breadcrumb-divider": ">" }}
          aria-label="breadcrumb"
        >
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="#"></Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="#"></Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page"></li>
          </ol>
        </nav>
      </div>

      <div className="container pb-4">
        <div className="box-bdr-dash">
          <div className="row">
            {/* ✅ Show Sidebar only if not accessed from header */}
            {!isHeaderLink && <Sidebar />}

            <div className={isHeaderLink ? "col-md-12" : "col-md-10"}>
              <div className="box mb-2">
                <iframe
                  src="https://fhir.ifirehealth.com/"
                  width="100%"
                  height="7000px"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Hapi_Fhir;
